<script>
/**
 *
 */
import VControl from "@/components/Planning/Helpers/VControl";
import { EventBus } from "@/libraries/EventBus";
import ProjectActionService from "@/services/ProjectActionService";
import VActionableTable from "./VActionableTable";

export default {
    props: {
        project_id: {},
        project_mom_id: {}
    },
    components: { VControl, VActionableTable },
    data() {
        return {
            showSection: true,
            openActions: []
        };
    },
    async created() {
        EventBus.$on("data-tab-open", () => {
            this.showSection = true;
        });
        EventBus.$on("data-tab-close", () => {
            this.showSection = false;
        });

        // 12.01.26 MIS keep always open
        // await this.checkIfOpen();
    },
    beforeDestroy() {
        EventBus.$off("data-tab-open");
        EventBus.$off("data-tab-close");
    },
    methods: {
        async checkIfOpen() {
            try {
                const { data } = await ProjectActionService.GET_shouldOpen(
                    this.project_id,
                    2
                );
                if (data.data["should_open"] === true) {
                    this.showSection = true;
                }
            } catch (e) {
                console.log("E checkIfOpen", e);
            }
        }
    }
};
</script>

<template>
    <div class="v-actionable-actions">
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <div class="mb-3">
                        <v-control
                            :show="showSection"
                            @trigger="showSection = !showSection"
                        >
                            <h3 class="pb-0 mb-0">
                                {{ $t("project_actions.actionable_list") }}
                            </h3>
                        </v-control>
                    </div>

                    <template v-if="showSection">
                        <card body-classes="px-0">
                            <v-actionable-table
                                :project-id="project_id"
                                :project-mom-id="project_mom_id"
                            />
                        </card>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
